import React, { useEffect } from 'react';
/// React router dom
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { navtoggle } from '../store/actions/AuthActions';
/// Css
import './index.css';
import './chart.css';
import './step.css';

/// Layout
import Nav from './layouts/nav';
import Footer from './layouts/Footer';
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';

/// Dashboard
import Home from './components/Dashboard/Home';

/// Pages
import Registration from './pages/Registration';
import LockScreen from './pages/LockScreen';
import Error400 from './pages/Error400';
import Error403 from './pages/Error403';
import Error404 from './pages/Error404';
import Error500 from './pages/Error500';
import Error503 from './pages/Error503';
import Todo from './pages/Todo';

//Scroll To Top
import Login from './pages/Login';
import ScrollToTop from './layouts/ScrollToTop';

import Users from './components/Masters/Users/UsersList';
import OrgType from './components/Masters/GlobalType/GlobalTypeList';
import City from './components/Masters/City/CityList';
import Area from './components/Masters/Area/AreaList';
import Software from './components/Masters/SoftwareName/SoftwareList';
import Clients from './components/Clients/ClientsList';
import InstallationDetailsList from './components/InstallationDetails/InstallationList';
import AmcList from './components/AMC/AmcList';
import DcrList from './components/DCR/DcrList';
import ProductList from './components/Issue_Tracker/Product/product_main';
import IssuesList from './components/Issue_Tracker/Issues/issues_main';
import RoleList from './components/UsersRights/AddUserRights';

const Markup = () => {
  const allroutes = [
    /// pages
    { url: 'page-register', component: <Registration /> },
    { url: 'page-lock-screen', component: <LockScreen /> },
    { url: 'page-error-400', component: <Error400 /> },
    { url: 'page-error-403', component: <Error403 /> },
    { url: 'page-error-404', component: <Error404 /> },
    { url: 'page-error-500', component: <Error500 /> },
    { url: 'page-error-503', component: <Error503 /> },
    { url: 'todo', component: <Todo /> },

    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },
    { url: 'page-login', component: <Login /> },
    { url: 'users', component: <Users /> },
    { url: 'orginisation-type', component: <OrgType /> },
    { url: 'speciality', component: <OrgType /> },
    { url: 'designation', component: <OrgType /> },
    { url: 'modules', component: <OrgType /> },
    { url: 'call-type', component: <OrgType /> },
    { url: 'demo-status', component: <OrgType /> },
    { url: 'user-non-user', component: <OrgType /> },
    { url: 'city', component: <City /> },
    { url: 'area', component: <Area /> },
    { url: 'softwares', component: <Software /> },
    { url: 'clients', component: <Clients /> },
    { url: 'installation-details', component: <InstallationDetailsList /> },
    { url: 'amc-list', component: <AmcList /> },
    { url: 'dcr-clients', component: <Clients /> },
    { url: 'dcr-area', component: <Area /> },
    { url: 'dcr-city', component: <City /> },
    { url: 'dcr-list', component: <DcrList /> },
    { url: 'products', component: <ProductList /> },
    { url: 'issues', component: <IssuesList /> },
    { url: 'users-rights', component: <RoleList /> }
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={<ProtectedRoute routePath={`/${data.url}`}>{data.component}</ProtectedRoute>}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const dispatch = useDispatch();

  useEffect(() => {
    const applyResponsiveSidebar = () => {
      const w = window.innerWidth;
      const body = document.body;
      const wrapper = document.getElementById('main-wrapper');
      if (!wrapper) return;

      if (w >= 992) {
        // ─── lg+ : full sidebar always visible, pushes content ──────────────
        body.setAttribute('data-sidebar-style', 'full');
        body.setAttribute('data-layout', 'vertical');
        wrapper.classList.remove('iconhover-toggle');
        wrapper.classList.add('menu-toggle');
        dispatch({ type: 'SIDEBAR_SET', payload: true });
      } else if (w >= 768) {
        // ─── md (iPad/tablet) : full sidebar as overlay, open by default ───
        // overlay = sidebar floats over content without pushing it
        // No menu-toggle = sidebar visible on load
        body.setAttribute('data-sidebar-style', 'overlay');
        body.setAttribute('data-layout', 'vertical');
        wrapper.classList.remove('iconhover-toggle');
        wrapper.classList.add('menu-toggle');
        dispatch({ type: 'SIDEBAR_SET', payload: true });
      } else {
        // ─── sm / xs : sidebar hidden, hamburger opens overlay ─────────
        body.setAttribute('data-sidebar-style', 'overlay');
        body.setAttribute('data-layout', 'vertical');
        wrapper.classList.remove('iconhover-toggle');
        wrapper.classList.add('menu-toggle');
        dispatch({ type: 'SIDEBAR_SET', payload: true });
      }
    };

    applyResponsiveSidebar();
    window.addEventListener('resize', applyResponsiveSidebar);
    return () => window.removeEventListener('resize', applyResponsiveSidebar);
  }, [dispatch]);

  // Handle outside click to close sidebar
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const sidebar = document.querySelector('.deznav');
      const navHeader = document.querySelector('.nav-header');
      const sidebarStyle = document.body.getAttribute('data-sidebar-style');
      const isOverlay = sidebarStyle === 'overlay';
      const isSidebarOpen = isOverlay ? sideMenu : !sideMenu;

      if (isSidebarOpen) {
        // Check if click is outside sidebar and nav header
        if (
          sidebar &&
          !sidebar.contains(event.target) &&
          navHeader &&
          !navHeader.contains(event.target)
        ) {
          dispatch(navtoggle());
        }
      }
    };

    // Add event listener when sidebar is open
    const sidebarStyle = document.body.getAttribute('data-sidebar-style');
    const isOverlay = sidebarStyle === 'overlay';
    const isSidebarOpen = isOverlay ? sideMenu : !sideMenu;

    if (isSidebarOpen) {
      document.addEventListener('click', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [sideMenu, dispatch]);

  return (
    <div id="main-wrapper" className={`show ${sideMenu ? 'menu-toggle' : ''}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 15 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;
